var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewRoles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BCA2D2D1-9018-47D6-ADD6-84D65447DA65") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 2.5 0 2.5 5.9375 0 5.9375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 2.5 0 2.5 2.5 0 2.5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Admin",
    transform: "translate(-91.000000, -2081.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-roles",
    transform: "translate(91.000000, 2081.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#E5E5E5",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(7.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 3.750000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0112971079,2.95707249 C0.0112971079,2.32784371 -0.0123776713,1.69755646 0.0184112042,1.06966468 C0.0454097825,0.519597837 0.522812289,0.0691379918 1.06867339,0.00891698112 C1.68678339,-0.0593260698 2.24378214,0.269131913 2.42559978,0.822819817 C2.47119997,0.961645681 2.49324201,1.11317311 2.49394176,1.25896255 C2.4993648,2.39753518 2.5041464,3.53616352 2.49429163,4.67462474 C2.48857703,5.33109503 2.12418369,5.76835194 1.50484913,5.90762347 C0.816297915,6.06243771 0.111827451,5.59788358 0.0192275759,4.92765326 C0.0115886693,4.87261315 0.00103414945,4.8172945 0.000917524918,4.76208726 C-0.000423657158,4.16043424 0.00010115322,3.55872551 0.00010115322,2.95707249 L0.0112971079,2.95707249 Z",
    id: "Fill-1",
    fill: "#1D1D1B",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000729009,1.2050331 C0.0252072027,0.491339413 0.596404097,-0.0254631787 1.33145263,0.000952604573 C1.98586367,0.0245047299 2.52684347,0.618684527 2.49896878,1.28334537 C2.47027424,1.96816871 1.89591509,2.51606245 1.22381885,2.49964024 C0.532280599,2.48280895 -0.0229293409,1.89511621 0.000729009,1.2050331",
    id: "Fill-4",
    fill: "#1D1D1B",
    mask: "url(#mask-4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRoles);
export default __webpack_public_path__ + "static/media/View-roles.1fc661ad511edd744694a69c08e8c0c2.svg";
export { ForwardRef as ReactComponent };